/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DcrRadioButton } from '@diekeure/dcr-components';
import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

export declare interface DcrRadioButtonComponent extends DcrRadioButton {}

@ProxyWebComponent()
@Component({
  standalone: true,
  selector: 'dcr-radio-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['label', 'supportingText', 'value', 'checked', 'disabled', 'invalid'],
})
export class DcrRadioButtonComponent extends BaseProxyComponent {}
